export default "/app/themes/macleod/public/images/dropdown-button.svg?7f91e9e55f3cca48c0b914587f4e252b";